import React from 'react';
import styled from 'styled-components';
import { HelpMessage } from '~/components';

const PreMessage = styled.div`
  white-space: pre-wrap;
  font-style: normal;
  word-break: break-word;
`;

// The project's accounting notes head every ledger, the way they headed the drawer's single Accounting tab —
// whoever is invoicing reads them wherever they land, not only on the ledger that happens to come first.
export default function AccountingNotes({ notes }) {
  if (!notes) return null;

  return (
    <HelpMessage spaceBottom>
      <PreMessage>
        <strong>Accounting Notes:</strong>
        <br />
        {notes}
      </PreMessage>
    </HelpMessage>
  );
}
